// MODULES
import React from "react";
import PropTypes from "prop-types";

// CLASSES
import Session from "@classes/Session";

// COMPONENTS
import DefaultFields from "../../../components/DefaultFields/DefaultFields";

// HELPERS
import {createClassName} from "@helpers/utils";
import * as CobHelpers from "../../../Cob.helpers";
import fulfillmentCheck from "./KycChanges.fulfillment";
import EditableField from "../../../components/EditableField/EditableField";
import OptionsList from "../../../components/OptionsList/OptionsList";
import imgDownload from "@assets/img/ic_download.svg";
import Checkbox from "../../../../../components/Checkbox/Checkbox";
import NumberField from "../../../components/NumberField/NumberField";
import api from "../../../../../helpers/api";
import ActivityIndicator from "../../../../../components/ActivityIndicator/ActivityIndicator";
import Validator from "../../../../../classes/Validator";


export default class KycChanges extends React.PureComponent
{
	static propTypes = {
		id: PropTypes.string.isRequired,
		title: PropTypes.string.isRequired,
		session: PropTypes.instanceOf(Session).isRequired,
		sectionNumber: PropTypes.number.isRequired,
		number: PropTypes.number.isRequired,
		prevState: PropTypes.object,
		onChange: PropTypes.func.isRequired
	};

	static companyExclusive = false;
	static privateExclusive = false;
	static fields = _getFields();

	state = _getInitialState.call(this);

	componentDidUpdate(prevProps, prevState)
	{
		const {props, state} = this;
		const {id, onChange} = props;

		if (prevState.fields !== state.fields)
		{
			onChange(id, {...state}, fulfillmentCheck(props, state));
		}
	}


	render()
	{
		const {props, state} = this;
		const {title, session} = props;
		const classes = createClassName("Cob-CustomerInformation", {
			"Cob-View": true,
			"fulfilled": state.isFulfilled
		});

		const today = new Date();
		let month = (today.getMonth() + 1);
		if (month < 10)
		{
			month = "0" + month;
		}

		let day = today.getDate();
		if (day < 10)
		{
			day = "0" + day;
		}

		let date = today.getFullYear() + '-' + month + '-' + day;

		let pageTitle = title;
		let subjectDitt = "ditt";
		let subjectDin = "din";
		let subjectDina = "dina";
		let subjectDu = "du";
		if (session.isCompany)
		{
			pageTitle = "Förändringar sedan företagets senaste rådgivning";
			subjectDitt = "företagets";
			subjectDin = "företagets";
			subjectDina = "företagets";
			subjectDu = "företaget";
		}

		const firstQuestionText = "Har något avseende " + subjectDin + " ekonomiska situation förändrats i så pass stor utsträckning att " +
			subjectDin + " ekonomiska situation skulle beskrivas som annorlunda idag jämfört med när " + subjectDu + " fick rådgivning " +
			"senast? Det kan anses vara annorlunda om " + subjectDu + " exempelvis har större/fler skulder eller högre utgifter än " +
			"när senast vi sågs.";

		return (
			<div className={classes}>
				<DefaultFields fields={this.constructor.fields} />

				<div className="Cob-Fields">
					<h2>{pageTitle}</h2>
					<input type="hidden" name="date" value={date} />
					<input type="hidden" name="has_downloadable_documentation" value={state.hasDownloadableDocumentation ? "yes" : "no"} />

					{state.hasDownloadableDocumentation && (
						<React.Fragment>
							<p style={{marginTop: "0", marginBottom: "30px"}}>
								Du hittar {subjectDitt} senaste rådgivningsprotokoll här:<br />
								<span onClick={this._onDownloadProtocol} style={{
									color: "#2972df",
									cursor: "pointer",
									fontSize: "12px",
									fontWeight: "600",
									display: "flex",
									alignItems: "center",
									marginTop: "5px"
								}}>
							<img src={imgDownload} style={{height: "19px", marginRight: "7px"}} alt="Ladda ner" />
							Ladda ner senaste rådgivningsprotokoll
						</span>
							</p>

							{state.downloading && (
								<div style={{marginTop: "-55px", marginBottom: "17px", marginLeft: "260px"}}>
									<ActivityIndicator/>
								</div>
							)}

							{state.downloadError && (
								<div className="Notice warning" style={{marginTop: "-10px", marginBottom: "20px"}}>
									Rådgivningsprotokollet kunde inte laddas ner. Var god kontakta din rådgivare.
								</div>
							)}
						</React.Fragment>
					)}

					{!session.isCompany && (
						<React.Fragment>
							<OptionsList
								type="radio"
								orientation="horizontal"
								name="radio_kyc_updt_sek5"
								description={firstQuestionText}
								options={state.fields.radio_kyc_updt_sek5.options}
								onChange={this._onOptionsListChange}
							/>

							{state.fields.radio_kyc_updt_sek5.options[1].checked && (
								<EditableField
									name="customer_situation_changed_description"
									label={"Beskriv hur " + subjectDin + " ekonomiska situation har förändrats"}
									value={state.fields.customer_situation_changed_description}
									valid={state.fields.customer_situation_changed_description.length > 0}
									onChange={this._onFieldChange}
									onBlur={this._onFieldBlur}
									required
									style={{marginTop: "20px"}}
								/>
							)}
						</React.Fragment>
					)}

					<OptionsList
						type="radio"
						orientation="horizontal"
						name="radio_kyc_updt_invgoals"
						description={"Har " + subjectDina + " investeringsmål förändrats?"}
						options={state.fields.radio_kyc_updt_invgoals.options}
						onChange={this._onOptionsListChange}
						style={!session.isCompany ? {marginTop: "30px"} : {}}
					/>

					{state.fields.radio_kyc_updt_invgoals.options[1].checked && (
						<EditableField
							name="customer_goals_changed_description"
							label={"Beskriv hur " + subjectDina + " investeringsmål har förändrats"}
							value={state.fields.customer_goals_changed_description}
							valid={state.fields.customer_goals_changed_description.length > 0}
							onChange={this._onFieldChange}
							onBlur={this._onFieldBlur}
							required
							style={{marginTop: "20px"}}
						/>
					)}

					<OptionsList
						type="radio"
						orientation="horizontal"
						name="radio_kyc_updt_risktaking"
						description={"Har " + subjectDin + " riskbenägenhet förändrats?"}
						options={state.fields.radio_kyc_updt_risktaking.options}
						onChange={this._onOptionsListChange}
						style={{marginTop: "30px"}}
					/>

					{state.fields.radio_kyc_updt_risktaking.options[1].checked && (
						<EditableField
							name="customer_risktaking_changed_description"
							label={"Beskriv hur " + subjectDin + " riskbenägenhet har förändrats"}
							value={state.fields.customer_risktaking_changed_description}
							valid={state.fields.customer_risktaking_changed_description.length > 0}
							onChange={this._onFieldChange}
							onBlur={this._onFieldBlur}
							required
							style={{marginTop: "20px"}}
						/>
					)}

					<OptionsList
						type="radio"
						orientation="horizontal"
						name="radio_kyc_updt_invhorizon"
						description={"Har " + subjectDin + " placeringshorisont förändrats?"}
						options={state.fields.radio_kyc_updt_invhorizon.options}
						onChange={this._onOptionsListChange}
						style={{marginTop: "30px"}}
					/>

					{state.fields.radio_kyc_updt_invhorizon.options[1].checked && (
						<EditableField
							name="customer_invhorizon_changed_description"
							label={"Beskriv hur " + subjectDin + " placeringshorisont har förändrats"}
							value={state.fields.customer_invhorizon_changed_description}
							valid={state.fields.customer_invhorizon_changed_description.length > 0}
							onChange={this._onFieldChange}
							onBlur={this._onFieldBlur}
							required
							style={{marginTop: "20px"}}
						/>
					)}

					<OptionsList
						type="radio"
						orientation="horizontal"
						name="radio_hallbarhet_has_preferences"
						description={"Har " + subjectDu + " några hållbarhetspreferenser enligt bilagan ”Information om hållbarhetspreferenser”?"}
						options={state.fields.radio_hallbarhet_has_preferences.options}
						onChange={this._onOptionsListChange}
						style={{marginTop: "30px"}}
					/>
					<a href={"https://assets.fairinvestments.se/fair-bilagor.pdf"}
						 style={{margin: "10px 0", fontSize: "11px", display: "flex", alignItems: "center"}}
						 target={"_blank"} rel="noreferrer">
						<img src={imgDownload} style={{height: "19px", marginRight: "7px"}} alt="Ladda ner"/>
						Se avsnitt "Information om hållbarhetspreferenser" (sid 28, avsnitt 9)
					</a>

					{state.fields.radio_hallbarhet_has_preferences.options[1].checked && (
						<React.Fragment>
							<p style={{fontWeight: "600"}}>
								Vilken/vilka av följande instrumenttyper avser {" " + subjectDina + " "}
								hållbarhetspreferenser?
							</p>

							<Checkbox style={{maxWidth: "540px"}}
												name="checkbox_hallbarhet_852"
												label="Ett finansiellt instrument i fråga om vilket kunden bestämmer att en viss minimiandel ska investeras i miljömässigt hållbara investeringar enligt definitionen i artikel 2.1 i Europaparlamentets och rådets förordning (EU) 2020/852."
												value="yes"
												checked={state.fields.checkbox_hallbarhet_852 === "yes"}
												onChange={checked => this.setState({fields: {...state.fields, checkbox_hallbarhet_852: checked ? "yes" : "no"}})}
												className={"smallText"}
							/>

							{state.fields.checkbox_hallbarhet_852 === "yes" && (
								<div style={{margin: "10px 0 0 40px", display: "block", maxWidth: "150px"}}>
									<p style={{margin: "0", fontSize: "13px", fontWeight: "bold"}}>Minimiandel</p>
									<EditableField
										Component={NumberField}
										name="customer_hallbarhet_852_minimum"
										label="Ange i %"
										value={state.fields.customer_hallbarhet_852_minimum}
										valid={state.fields.customer_hallbarhet_852_minimum.length <= 0 ? null : state.fields.customer_hallbarhet_852_minimum > 0 && state.fields.customer_hallbarhet_852_minimum <= 100}
										onChange={this._onFieldChange}
										onBlur={this._onFieldBlur}
										required
										style={{marginTop: "5px"}}
									/>
								</div>
							)}

							<Checkbox style={{maxWidth: "540px", marginTop: "20px"}}
												name="checkbox_hallbarhet_2088"
												label="Ett finansiellt instrument i fråga om vilket kunden bestämmer att en viss minimiandel ska investeras i hållbara investeringar enligt definitionen i artikel 2.17 i Europaparlamentets och rådets förordning (EU) 2019/2088."
												value="yes"
												checked={state.fields.checkbox_hallbarhet_2088 === "yes"}
												onChange={checked => this.setState({fields: {...state.fields, checkbox_hallbarhet_2088: checked ? "yes" : "no"}})}
												className={"smallText"}
							/>

							{state.fields.checkbox_hallbarhet_2088 === "yes" && (
								<div style={{margin: "10px 0 0 40px", display: "block", maxWidth: "150px"}}>
									<p style={{margin: "0", fontSize: "13px", fontWeight: "bold"}}>Minimiandel</p>
									<EditableField
										Component={NumberField}
										name="customer_hallbarhet_2088_text"
										label="Ange i %"
										value={state.fields.customer_hallbarhet_2088_text}
										valid={state.fields.customer_hallbarhet_2088_text.length <= 0 ? null : state.fields.customer_hallbarhet_2088_text > 0 && state.fields.customer_hallbarhet_2088_text <= 100}
										onChange={this._onFieldChange}
										onBlur={this._onFieldBlur}
										required
										style={{marginTop: "5px"}}
									/>
								</div>
							)}

							<Checkbox style={{maxWidth: "540px", marginTop: "20px"}}
												name="checkbox_hallbarhet_customer"
												label="Ett finansiellt instrument som beaktar huvudsakliga negativa konsekvenser för hållbarhetsfaktorer i fråga om vilket kunden bestämmer vilka kvalitativa eller kvantitativa inslag som ska påvisa att så sker."
												value="yes"
												checked={state.fields.checkbox_hallbarhet_customer === "yes"}
												onChange={checked => this.setState({fields: {...state.fields, checkbox_hallbarhet_customer: checked ? "yes" : "no"}})}
												className={"smallText"}
							/>

							<Checkbox style={{maxWidth: "540px", marginTop: "20px"}}
									  name="checkbox_hallbarhet_art6"
									  label="Inget av ovan. Jag vill att hållbarhetsrisker ska integreras i investeringsbeslut enligt art. 6  i Europaparlamentets och rådets förordning (EU) 2019/2088 enligt följande."
									  value="yes"
									  checked={state.fields.checkbox_hallbarhet_art6 === "yes"}
									  onChange={checked => this.setState({fields: {...state.fields, checkbox_hallbarhet_art6: checked ? "yes" : "no"}})}
									  className={"smallText"}
							/>

							{state.fields.checkbox_hallbarhet_art6 === "yes" && (
								<div style={{margin: "0 0 0 40px", display: "block", width:"100%"}}>
									<EditableField
										name="customer_hallbarhet_art6_description"
										label={"Beskriv"}
										value={state.fields.customer_hallbarhet_art6_description}
										valid={state.fields.customer_hallbarhet_art6_description.length > 0}
										onChange={this._onFieldChange}
										onBlur={this._onFieldBlur}
										required
										style={{marginTop: "20px"}}
									/>
								</div>
							)}

						</React.Fragment>
					)}
				</div>
			</div>
		);
	}

	_onDownloadProtocol = () => {
		if (this.state.downloading)
		{
			return;
		}

		this.setState({downloadError: false, downloading: true}, async () => {
			try
			{
				const result = await api("/case/download/latest", {identityNo: this.state.identity, checksum: this.state.checksum});

				// Base64 decode, download the file
				const linkSource = `data:application/pdf;base64,${result.data}`;
				const downloadLink = document.createElement("a");
				const fileName = result.filename;
				downloadLink.href = linkSource;
				downloadLink.download = fileName;
				downloadLink.click();

				this.setState({downloadError: false, downloading: false});
			}
			catch (exception)
			{
				this.setState({downloadError: true, downloading: false});
			}
		});
	}

	// Internal methods
	_fieldValidator = (name, value) =>
	{
		if (name === "customer_social_security_number")
		{
			return this.props.session.isCompany ? Validator.validateOrgNum(value, true) : Validator.validateSsn(value, true);
		}
		else if (name === "customer_email")
		{
			return Validator.validateEmail(value);
		}
		else
		{
			return value.length > 0;
		}
	};

	_onFieldChange = (name, value) =>
	{
		CobHelpers.onViewFieldChange.call(this, name, value);
	};

	_onFieldBlur = (name) =>
	{
		CobHelpers.onViewFieldBlur.call(this, name);
	};

	_onOptionsListChange = ({type, name}, option, index) =>
	{
		const newOptions = [...this.state.fields[name].options].map((o, i) =>
		{
			if (i === index)
			{
				return option;
			}
			else
			{
				return {...o, checked: type === "radio" ? false : o.checked};
			}
		});

		this.setState({
			fields: {
				...this.state.fields,
				[name]: {
					options: newOptions
				}
			}
		}, () => fulfillmentCheck(this.props, this.state));
	};
}


// PRIVATE FUNCTIONS
function _getFields()
{
	return [];
}

function _getInitialState()
{
	if (this.props.prevState)
	{
		return {...this.props.prevState};
	}

	return {
		hasDownloadableDocumentation: this.props.hasDownloadableDocumentation,
		downloadError: false,
		downloading: false,
		identity: this.props.session.context.customer.id,
		checksum: this.props.session.context.customer.check,
		isCompany: this.props.session.isCompany,
		validFields: {},
		fields: {
			radio_kyc_updt_sek5: {options: _createYesNoOptions()},
			radio_kyc_updt_invgoals: {options: _createYesNoOptions()},
			radio_kyc_updt_risktaking: {options: _createYesNoOptions()},
			radio_kyc_updt_invhorizon: {options: _createYesNoOptions()},
			radio_hallbarhet_has_preferences: {options: _createYesNoOptions()},

			customer_situation_changed_description: "",
			customer_goals_changed_description: "",
			customer_risktaking_changed_description: "",
			customer_invhorizon_changed_description: "",
			customer_hallbarhet_art6_description: "",

			checkbox_hallbarhet_852: "",
			customer_hallbarhet_852_minimum: "",
			checkbox_hallbarhet_2088: "",
			customer_hallbarhet_2088_text: "",
			checkbox_hallbarhet_customer: "",
			checkbox_hallbarhet_art6: ""
		}
	};
}

function _createYesNoOptions()
{
	return [
		{label: "Nej", value: "no", checked: false},
		{label: "Ja", value: "yes", checked: false}
	];
}


// WEBPACK FOOTER //
// ./src/routes/Cob/views/Fair/Kyc/KycChanges.js